"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUUID = exports.API = void 0;

var _uuid = require("uuid");

/* eslint-disable max-len */
// import uuidv1 from 'uuid/v1';
var URL_API = 'https://www.movistar.es';
var NODE_ENV = process.env.NODE_ENV;

if (typeof LEGACY_CHANGE_ENV !== 'undefined' && LEGACY_CHANGE_ENV || NODE_ENV === 'development') {
  if (sessionStorage && sessionStorage.getItem('devEnvironment')) {
    var devEnvironment = sessionStorage.getItem('devEnvironment');

    switch (devEnvironment) {
      case 'INTE':
        URL_API = 'https://www.movistar.es.inte';
        break;

      case 'CERTI':
        URL_API = 'https://www.movistar.es.cert';
        break;

      case 'CERTI_PRE':
        URL_API = 'https://tsso-col10mgmt.tsm.inet.cert';
        break;

      default:
        URL_API = 'https://col10mgmt.tsm.inet';
        break;
    }
  } else {
    URL_API = 'https://col10mgmt.tsm.inet';
  }
}

var URL_API_MOCK = 'https://europe-west1-mov-dev6.cloudfunctions.net/mooks-storage?url=legadoApis/';
var API = {
  CLIENT: {
    CONSULTA_DATOS_CLIENTE_G: "".concat(URL_API, "/srvPrivCol/Consulta/Cliente/ConsultaDatosClienteG"),
    CONSULTA_DATOS_CLIENTE_G_FIRMA_SOLO_MOVIL: "".concat(URL_API, "/srvLogmCol/Consulta/Cliente/ConsultaDatosClienteG"),
    CONSULTA_DATOS_CLIENTE_G_FIRMA: "".concat(URL_API, "/srvSecCol/Consulta/Cliente/ConsultaDatosClienteG"),
    CONSULTA_DATOS_CLIENTE_G_MOCK: "".concat(URL_API_MOCK, "client/consultaDatosClienteG.json"),
    CONSULTA_DATOS_CLIENTE_M: "".concat(URL_API, "/srvPrivCol/Consulta/Cliente/ConsultaDatosClienteM"),
    CONSULTA_DATOS_CLIENTE_M_FIRMA: "".concat(URL_API, "/srvSecCol/Consulta/Cliente/ConsultaDatosClienteM"),
    CONSULTA_DATOS_CLIENTE_M_MOCK: "".concat(URL_API_MOCK, "client/consultaDatosClienteM.json"),
    CONSULTA_DATOS_BANCARIOS: "".concat(URL_API, "/srvPrivCol/Consulta/Linea/ConsultaDatosBancarios"),
    CONSULTA_DATOS_BANCARIOS_FIRMA: "".concat(URL_API, "/srvSecCol/Consulta/Linea/ConsultaDatosBancarios"),
    CONSULTA_DATOS_BANCARIOS_MOCK: "".concat(URL_API_MOCK, "client/consultaDatosBancarios.json"),
    CONSULTA_PARQUE: "".concat(URL_API, "/srvPrivCol/Consulta/Linea/ConsultaParqueF"),
    CONSULTA_PARQUE_FIRMA: "".concat(URL_API, "/srvSecCol/Consulta/Linea/ConsultaParqueF"),
    CONSULTA_PARQUE_MOCK: "".concat(URL_API_MOCK, "client/consultaParque.json"),
    CONSULTA_DATOS_LINEA_F: "".concat(URL_API, "/srvPrivCol/Consulta/Linea/ConsultaLineasF"),
    CONSULTA_DATOS_LINEA_F_FIRMA: "".concat(URL_API, "/srvSecCol/Consulta/Linea/ConsultaLineasF"),
    CONSULTA_DATOS_LINEA_F_MOCK: "".concat(URL_API_MOCK, "client/consultaLineasF.json"),
    CONSULTA_DATOS_LINEA_M: "".concat(URL_API, "/srvPrivCol/Consulta/Linea/ConsultaDatosLineaM"),
    CONSULTA_DATOS_LINEA_M_FIRMA: "".concat(URL_API, "/srvSecCol/Consulta/Linea/ConsultaDatosLineaM"),
    CONSULTA_DATOS_LINEA_M_MOCK: "".concat(URL_API_MOCK, "client/consultaDatosLineaM.json"),
    CONSULTAR_DATOS_NOTARIALES: "".concat(URL_API, "/srvPrivCol/TMA/DatosNotariales/Consultar"),
    CONSULTAR_DATOS_NOTARIALES_FIRMA: "".concat(URL_API, "/srvSecCol/TMA/DatosNotariales/Consultar"),
    CONSULTAR_DATOS_NOTARIALES_MOCK: "".concat(URL_API_MOCK, "client/DatosNotarialesLectura.json"),
    GUARDAR_DATOS_NOTARIALES: "".concat(URL_API, "/srvPrivCol/TMA/DatosNotariales/Guardar"),
    GUARDAR_DATOS_NOTARIALES_FIRMA: "".concat(URL_API, "/srvSecCol/TMA/DatosNotariales/Guardar"),
    GUARDAR_DATOS_NOTARIALES_MOCK: "".concat(URL_API_MOCK, "client/DatosNotarialesEscritura.json")
  },
  ADDRESS: {
    CONSULTA_CALLES_CP: "".concat(URL_API, "/srvCntr/ConsultaCallesCP"),
    CONSULTA_CALLES_CP_FIRMA: "".concat(URL_API, "/srvCntr/ConsultaCallesCP"),
    CONSULTA_CALLES_CP_MOCK: "".concat(URL_API_MOCK, "client/consultaCallesCP.json"),
    CONSULTA_CALLES: "".concat(URL_API, "/srvCntr/ConsultaCalles"),
    CONSULTA_CALLES_FIRMA: "".concat(URL_API, "/srvCntr/ConsultaCalles"),
    CONSULTA_CALLES_MOCK: "".concat(URL_API_MOCK, "client/consultaCalles.json"),
    TRADUCCION_BI: "".concat(URL_API, "/srvPubCol/Consulta/Dir/TraduccionBi"),
    TRADUCCION_BI_MOCK: "".concat(URL_API_MOCK, "addresses/traduccionBi.json"),
    CONSULTA_FINCAS: "".concat(URL_API, "/srvPubCol/Consulta/Dir/ConsultaFincas"),
    CONSULTA_FINCAS_FIRMA: "".concat(URL_API, "/srvPubCol/Consulta/Dir/ConsultaFincas"),
    CONSULTA_FINCAS_MOCK: "".concat(URL_API_MOCK, "client/consultaFincas.json "),
    CONSULTA_DOMICILIOS: "".concat(URL_API, "/srvPubCol/Consulta/Dir/ConsultaDomicilios"),
    CONSULTA_DOMICILIOS_FIRMA: "".concat(URL_API, "/srvPubCol/Consulta/Dir/ConsultaDomicilios"),
    CONSULTA_DOMICILIOS_MOCK: "".concat(URL_API_MOCK, "client/consultaDomicilios.json ")
  },
  PRODUCT: {
    CONSULTA_OFERTA_EXTENDIDA: "".concat(URL_API, "/srvPubCntr/Consulta/Oferta/ConsultaOfertaExtendida"),
    CONSULTA_OFERTA_EXTENDIDA_EMPRESAS: "".concat(URL_API, "/srvPubCol/Consulta/Oferta/ConsultaOfertaExtendida"),
    CONSULTA_OFERTA_EXTENDIDA_MOCK: "".concat(URL_API_MOCK, "product/consultaOfertaExtendida.json"),
    CONSULTA_OFERTA_EXTENDIDA_FIRMA: "".concat(URL_API, "/srvPubCol/Consulta/Oferta/ConsultaOfertaExtendida"),
    CONSULTA_STOCK: "".concat(URL_API, "/srvPubCol/Consulta/ConsultaStockSAP"),
    CONSULTA_STOCK_MOCK: "".concat(URL_API_MOCK, "product/ConsultaStock.json"),
    CONSULTAR_CARRITO: "".concat(URL_API, "/srvPrivCol/TMA/Carrito/Consulta"),
    CONSULTAR_CARRITO_FIRMA: "".concat(URL_API, "/srvSecCol/TMA/Carrito/Consulta"),
    CONSULTAR_CARRITO_MOCK: "".concat(URL_API_MOCK, "product/RecuperarCarrito.json"),
    GUARDAR_CARRITO: "".concat(URL_API, "/srvPrivCol/TMA/Carrito/Guardar"),
    GUARDAR_CARRITO_FIRMA: "".concat(URL_API, "/srvSecCol/TMA/Carrito/Guardar"),
    GUARDAR_CARRITO_MOCK: "".concat(URL_API_MOCK, "product/AlmacenarCarrito.json")
  },
  PEDIDO: {
    VALIDAR_CNTR_M: "".concat(URL_API, "/srvPubCol/Validacion/Cntr/ValidarCntrM"),
    VALIDAR_CNTR_M_MOCK: "".concat(URL_API_MOCK, "client/consultaValidarCntrM.json"),
    VALIDAR_CNTR_M_FIRMA: "".concat(URL_API, "/srvPubCol/Validacion/Cntr/ValidarCntrM"),
    GENERA_PRESENTACION_GESTION: "".concat(URL_API, "/srvPubCol/Cntr/Consulta/GeneraPresentacionGestion"),
    GENERA_PRESENTACION_GESTION_FIRMA: "".concat(URL_API, "/srvPubCol/Cntr/Consulta/GeneraPresentacionGestion"),
    GENERA_PRESENTACION_GESTION_MOCK: "".concat(URL_API_MOCK, "client/generaPresentacionGestion.json"),
    CONTRATAR_FM: "".concat(URL_API, "/srvPubCol/Cntr/Alta/ContratarFM"),
    CONTRATAR_FM_FIRMA: "".concat(URL_API, "/srvPubCol/Cntr/Alta/ContratarFM"),
    CONTRATAR_MOCK: "".concat(URL_API_MOCK, "client/contratarFM.json"),
    CONSULTA_GESTION: "".concat(URL_API, "/srvPubCol/Cntr/Consulta/ConsultaGestion"),
    CONSULTA_GESTION_FIRMA: "".concat(URL_API, "/srvPubCol/Cntr/Consulta/ConsultaGestion"),
    CONSULTA_GESTION_MOCK: "".concat(URL_API_MOCK, "client/consultaGestion.json"),
    VALIDACION_RIESGO: "".concat(URL_API, "/srvPrivCol/Validacion/ValidacionRiesgo"),
    VALIDACION_RIESGO_FIRMA: "".concat(URL_API, "/srvSecCol/Validacion/ValidacionRiesgo"),
    VALIDACION_RIESGO_MOCK: "".concat(URL_API_MOCK, "pedido/validacionRiesgo.json"),
    REGISTRO_NAVEGACION: "".concat(URL_API, "/srvPubCol/Registro/Nav/RegistroNavegacion"),
    REGISTRO_NAVEGACION_MOCK: "".concat(URL_API_MOCK, "pedido/registroNavegacion.json"),
    VALIDA_CANJE_LINEA: "".concat(URL_API, "/srvPrivCntr/Validacion/Canje/ValidarCanjeLinea"),
    VALIDA_CANJE_LINEA_MOCK: "".concat(URL_API_MOCK, "pedido/validaCanjeLinea.json"),
    GENERACION_CANJE_PEDIDO: "".concat(URL_API, "/srvPrivCntr/Cntr/Canje/GeneracionCanjePedido"),
    GENERACION_CANJE_PEDIDO_MOCK: "".concat(URL_API_MOCK, "pedido/generacionCanjePedido.json"),
    CONSULTA_OPERACION: "".concat(URL_API, "/srvCntr/F2/ConsultaOperacion"),
    CONSULTA_OPERACION_MOCK: "".concat(URL_API_MOCK, "pedido/consultaOperacion.json"),
    FIRMA_CONTRATO: "".concat(URL_API, "/srvPrivCol/Validacion/FirmaContrato"),
    FIRMA_CONTRATO_MOCK: "".concat(URL_API_MOCK, "pedido/firmaContrato.json")
  },
  FACILITY: {
    ESTABLECE_IDENTIFICACION: "".concat(URL_API, "/srvSecCol/Ident/EstableceIdentificacion"),
    ESTABLECE_IDENTIFICACION_FIRMA_MOVIL: "".concat(URL_API, "/srvLogmCol/Ident/EstableceIdentificacion")
  },
  JSON: {
    NEXT_STEPS: "".concat(URL_API_MOCK, "json/nextSteps/nextSteps.json")
  },
  TERMINAL: {
    ENVIO_ZELERIS: 'https://intext.zeleris.com/movistar/WEBTde_EstadoPedido.asmx',
    ENVIO_ZELERIS_MOCK: "".concat(URL_API_MOCK, "terminal/envioZeleris.json")
  }
};
exports.API = API;

var getUUID = function getUUID(idFront) {
  var v1options = {
    node: [0x01, 0x23, 0x45, 0x67, 0x89, 0xab],
    clockseq: 0x1234,
    msecs: new Date().getTime(),
    nsecs: 5678
  };
  var uuid = (0, _uuid.v1)(v1options);
  uuid = uuid.replace(/-/g, '');
  uuid = uuid.toUpperCase();
  return "idPeticion=".concat(idFront).concat(uuid);
};

exports.getUUID = getUUID;

//# sourceMappingURL=legadoApi.js.map